import {
  Component,
  Input,
  OnDestroy,
  OnInit,
  Output,
  EventEmitter,
  SimpleChanges,
} from "@angular/core";
import { NgbDatepickerI18n } from "@ng-bootstrap/ng-bootstrap";
import { BasePagingRequest } from "src/app/core/models/requests/base-paging-request";
import { BasePagingResponse } from "src/app/core/models/responses/base-paging-response";
import { SelectItem } from "src/app/core/models/responses/select-item";
import { AlertService } from "src/app/services/alert.service";
import { DataService } from "src/app/services/data.service";
import { BaseListComponent } from "src/app/shared/components/base-list/base-list.component";
import { AccountTransaction } from "src/app/models/account-transaction/account-transaction";
import { AccountTransactionReason } from "src/app/models/enums/account-transaction-reason";
import { AccountTransactionType } from "src/app/models/enums/account-transaction-type";
import { ExchangeItem } from "src/app/models/exchange/exchange-item-request";
import { AccountTransactionFilter } from "src/app/models/filters/account-transaction-filter";
import { FilterAreas } from "src/app/models/filters/filter-areas";
import { CurrencySubTypes } from "src/app/models/enums/currency-sub-types";
import {
  DatePickerTrLangService,
  I18n,
} from "src/app/services/date-picker-tr-lang.service";
import { AccountTransactionService } from "src/app/services/account-transaction.service";
import { CustomerService } from "src/app/services/customer.service";
import { ExchangeService } from "src/app/services/exchange.service";
import { SalesService } from "src/app/services/sales.service";
import { Sales } from "src/app/models/sales/sales";
import { Customer } from "src/app/models/customer/customer";
import { getCurrencySubTypeItem } from "src/app/core/helpers/common-functions";
import { AllCurrencyList } from "src/app/models/enums/currency";

@Component({
  selector: "app-account-transaction-list",
  templateUrl: "./account-transaction-list.component.html",
  styleUrls: ["./account-transaction-list.component.scss"],
  providers: [
    I18n,
    { provide: NgbDatepickerI18n, useClass: DatePickerTrLangService },
  ],
})
export class AccountTransactionListComponent
  extends BaseListComponent
  implements OnInit, OnDestroy
{
  @Input() filter?: AccountTransactionFilter;
  @Input() showFilterAreas?: boolean = true;
  @Input() filterAreas?: FilterAreas;
  @Input() showAsPartial: boolean = false;
  @Input() showHeader: boolean = false;
  @Input() showBalanceField: boolean = false;
  @Input() showSelectionField: boolean = false;
  @Input() showCaseField: boolean = true;
  @Input() showExpenseField: boolean = false;
  @Input() showCreaterField: boolean = false;
  @Output() transactionForBalanceDate = new EventEmitter();

  Type = AccountTransactionType;
  collectionCaseName;
  dateSelectedForBalance: boolean = false;
  branch = JSON.parse(localStorage.getItem("currentBranch"));
  expenseList: SelectItem[] = [];
  defaultValue = null;
  salesDetail: Sales;
  request: BasePagingRequest<AccountTransactionFilter> = {
    pageIndex: this.pageIndex,
    itemPerPage: this.itemPerPage,
    filter: {
      branchId: this.branch.id,
      createrId: null,
      type: null,
      amount: null,
    },
  };
  applicationUsers: SelectItem[] = [];
  pageFilterAreas: FilterAreas = {
    case: true,
    customer: true,
    state: true,
    startDate: true,
    endDate: true,
    clearAll: true,
    expenses: true,
    amount: true,
  };

  currencyList = AllCurrencyList;
  accountTransactionTypes: AccountTransactionType[] = [
    AccountTransactionType.Receivable,
    AccountTransactionType.Debt,
  ];
  model: BasePagingResponse<AccountTransaction>;
  beginDateModel: any;
  endDateModel: any;
  customerList: SelectItem[];
  branchCases: SelectItem[];
  selectedCustomerId: number;
  reasonEnum = AccountTransactionReason;
  exchangeInfo: ExchangeItem = {};
  selectedIndex: number;
  transactionInfo: AccountTransaction = {};
  subTypeList: CurrencySubTypes[] = [];
  customerOfDetail: Customer;
  selectedItem: AccountTransaction;
  selectedItems: AccountTransaction[];
  selectedTransactionForReceiptIndex: number;
  private filterTimer: ReturnType<typeof setTimeout> | null = null;
  /**
   * Sayfanın verdiği kapsam (hesap, müşteri, kasa, birim...) açılıştaki hâliyle. Süzgeç
   * seçimleri request.filter üzerinden giriş nesnesini de değiştirdiği için temizleme
   * buna döner; eskiden hesap/müşteri düşüyor ve başka hesapların hareketleri listeleniyordu.
   */
  private scopeFilter: AccountTransactionFilter | null = null;
  constructor(
    private service: AccountTransactionService,
    private dataService: DataService,
    private customerService: CustomerService,
    private exchangeService: ExchangeService,
    private alertService: AlertService,
    private salesService: SalesService
  ) {
    super();
  }

  ngOnInit() {
    if (this.filter) {
      if (this.filter.customerId)
        this.filter.customerId = parseInt(this.filter.customerId.toString());
      else this.filter.customerId = null;
      if (!this.filter.type) this.filter.type = null;
      if (!this.filter.caseId) this.filter.caseId = null;

      this.request.filter = this.filter;
      if (this.filterAreas && this.filterAreas.subType) {
        this.currencyChanged();
      }
      this.request.filter.subType = null;
      this.request.filter.createrId = null;
      this.scopeFilter = { ...this.filter };
    } else {
      this.clearFilter();
    }
    if (this.showFilterAreas && this.filterAreas)
      this.pageFilterAreas = this.filterAreas;
    this.getApplicationUsers();
    this.service
      .getAll(this.request)
      .toPromise()
      .then((res) => {
        this.Loading = false;
        this.model = res;
      });
    this.service.refreshIndex.subscribe((res) => this.reloadData(true));
    this.dataService
      .getCustomer({ isActive: true })
      .toPromise()
      .then((res) => {
        this.customerList = res.data;
      });
    this.dataService
      // Rapor süzgeci: geçmiş hareketler banka kasalarında da olabilir, hepsi listelenmeli.
      .getCase({ branchId: this.branch.id, includeBankLinkedCases: true })
      .toPromise()
      .then((res) => (this.branchCases = res.data));
  }

  ngOnDestroy(): void {
    if (this.filterTimer) clearTimeout(this.filterTimer);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.filter && !changes.filter.firstChange) {
      this.request.filter = changes.filter.currentValue;
      this.scopeFilter = changes.filter.currentValue ? { ...changes.filter.currentValue } : null;
      this.reloadData();
    }
  }

  customerSelected() {
    this.filter.customerId = Number(this.filter.customerId);
    this.filter.type = null;
    this.reloadData(true);
  }

  stateSelected() {
    // this.request.filter.type = + this.request.filter.type;
    this.reloadData(true);
  }

  reloadData(isFiltered: boolean = false) {
    this.Loading = true;
    if (isFiltered) this.request.pageIndex = 1;

    // Tarih süzgeci kaldırılınca istekten de düşmeli; eskiden son seçilen tarih kalıyordu
    if (!this.beginDateModel) this.request.filter.beginDate = null;
    if (!this.endDateModel) this.request.filter.endDate = null;
    if (this.beginDateModel) {
      this.request.filter.beginDate = new Date();
      this.request.filter.beginDate.setFullYear(
        this.beginDateModel.year,
        this.beginDateModel.month - 1,
        this.beginDateModel.day
      );
    }

    if (this.endDateModel) {
      this.request.filter.endDate = new Date();
      this.request.filter.endDate.setFullYear(
        this.endDateModel.year,
        this.endDateModel.month - 1,
        this.endDateModel.day
      );
    }

    localStorage.setItem("itemPerPage", this.request.itemPerPage.toString());
    //this.request.filter.customerId = Number(this.request.filter.customerId)
    this.service
      .getAll(this.request)
      .toPromise()
      .then((res) => {
        this.Loading = false;
        this.model = res;
        this.model = JSON.parse(JSON.stringify(this.model));
      });
  }

  delete(id: number) {
    this.alertService.showDeleteAlert().then((result) => {
      if (result.isConfirmed) {
        this.service.delete(id).subscribe((res) => {
          if (res.isSuccess) {
            this.service.refreshIndex.next();
            this.alertService.showSuccess("Silme işlemi başarılı.");
            this.customerService.refreshIndex.next();
            this.reloadData(true);
          }
        });
      }
    });
  }

  /** Tutar araması yazarken uygulanır (e-fatura listesindeki gibi kısa gecikmeyle). */
  scheduleFilter() {
    if (this.filterTimer) clearTimeout(this.filterTimer);
    this.filterTimer = setTimeout(() => this.applyFilterNow(), 400);
  }

  applyFilterNow() {
    if (this.filterTimer) clearTimeout(this.filterTimer);
    this.filterTimer = null;
    this.request.filter.sortBy =
      this.request.filter.amount == null ? null : "Amount";
    this.reloadData(true);
  }

  hasAnyFilterArea(): boolean {
    return !!this.pageFilterAreas.amount || this.hasPanelFilterArea();
  }

  hasPanelFilterArea(): boolean {
    const a = this.pageFilterAreas;
    return !!(a.currency || a.subType || a.case || a.state || a.expenses || a.creater || a.startDate || a.endDate);
  }

  /** Panelde seçili süzgeç sayısı (Filtreler düğmesindeki rozet); yalnızca görünen alanlar sayılır. */
  panelFilterCount(): number {
    const a = this.pageFilterAreas;
    const f = this.request.filter;
    return [
      a.currency && f.currency != null,
      a.subType && f.subType != null,
      a.case && f.caseId != null,
      a.state && f.type != null,
      a.expenses && f.expenseTypeId != null,
      a.creater && f.createrId != null,
      (a.startDate || a.endDate) && (!!this.beginDateModel || !!this.endDateModel),
    ].filter(Boolean).length;
  }

  clearFilter() {
    if (this.filterTimer) clearTimeout(this.filterTimer);
    // Sayfanın açılıştaki hâline döner: kapsam (hesap, müşteri, kasa, birim) kalır, kullanıcı seçimleri kalkar
    const filter: AccountTransactionFilter = this.scopeFilter
      ? { ...this.scopeFilter }
      : { branchId: this.branch.id, createrId: null, type: null };
    filter.amount = null;
    filter.sortBy = null;
    this.request.filter = filter;
    this.beginDateModel = null;
    this.endDateModel = null;
    this.reloadData(true);
  }

  getExchangeDetails(exchangeId: number) {
    this.exchangeService
      .find(exchangeId)
      .toPromise()
      .then((res) => {
        this.exchangeInfo = res.data;
      });
  }

  getAccountTransactionDetails(id: number) {
    this.transactionInfo = {};
    this.service
      .find(id)
      .toPromise()
      .then((res) => {
        this.transactionInfo = res.data;
      });
  }

  getItemForBalance(item: AccountTransaction, checked: boolean) {
    if (item && checked) {
      this.transactionForBalanceDate.emit(item);
    } else {
      this.transactionForBalanceDate.emit(null);
    }
  }

  /**
   * Banka entegrasyonundan doğan hesap hareketi sebepleri. Bunların hepsi banka
   * hesabı / müşteri / açıklama alanlarını taşıdığı için tek bir bilgi balonuyla
   * gösteriliyor.
   */
  readonly bankRelatedReasons: AccountTransactionReason[] = [
    AccountTransactionReason.TcknVknMatch,
    AccountTransactionReason.IbanMatch,
    AccountTransactionReason.BankPayment,
    AccountTransactionReason.BankAutoCustomer,
    AccountTransactionReason.BankManualMatch,
  ];

  /** Türü (gider/gelir türü sözlüğü) olan sebepler: kasa gider/gelir ve şube para giriş/çıkışı. */
  readonly incomeExpenseReasons: AccountTransactionReason[] = [
    AccountTransactionReason.Expense,
    AccountTransactionReason.Income,
    AccountTransactionReason.BranchMoneyEntry,
    AccountTransactionReason.BranchMoneyExit,
  ];

  isIncomeExpenseReason(reason?: AccountTransactionReason): boolean {
    return reason != null && this.incomeExpenseReasons.includes(reason);
  }

  isBankRelatedReason(reason?: AccountTransactionReason): boolean {
    return reason != null && this.bankRelatedReasons.includes(reason);
  }

  getCaseNameById(item: AccountTransaction) {
    this.service
      .getCaseNameById(item.id)
      .toPromise()
      .then((res) => {
        if (res.isSuccess) {
          this.collectionCaseName = res.data.caseName;
        } else {
          this.collectionCaseName = null;
        }
      });
  }

  getApplicationUsers() {
    this.dataService
      .getApplicationUser({ isValid: true })
      .toPromise()
      .then((res) => (this.applicationUsers = res.data));
  }

  changeSelection(event, index, item) {
    this.selectedIndex = event.target.checked ? index : undefined;
    this.getItemForBalance(item, event.target.checked);
  }

  addSelections(event, item: AccountTransaction) {
    this.selectedItem = event.target.checked ? item : undefined;
    if (this.selectedItems == undefined) this.selectedItems = [];

    if (this.selectedItem == undefined)
      this.selectedItems = this.selectedItems.filter((p) => p.id != item.id);
    else this.selectedItems.push(this.selectedItem);
  }

  getSelections(): AccountTransaction[] {
    return this.selectedItems;
  }

  currencyChanged() {
    // request.filter: süzgeç girişi verilmeyen sayfada (hesap hareketleri) this.filter yok
    let item = getCurrencySubTypeItem(this.request.filter.currency);
    this.request.filter.currency = item.currency;
    this.subTypeList = item.subtypes;
  }

  getSales(salesId) {
    this.salesService
      .find(salesId)
      .toPromise()
      .then((res) => (this.salesDetail = res.data));
  }

  getCustomerByGroupId(groupId: string) {
    this.service
      .getCustomerByGroupId(groupId)
      .toPromise()
      .then((res) => (this.customerOfDetail = res.data));
  }
}
